
import { DashboardLayout } from "@/components/layouts/DashboardLayout";
import { TeamMatchingAI } from "@/features/team-matching/components/TeamMatchingAI";

export default function TeamMatching() {
  return (
    <DashboardLayout>
      <TeamMatchingAI />
    </DashboardLayout>
  );
}
